import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    globalVar: ''
  },
  mutations: {
    setGlobalVar(state, value) {
      state.globalVar = value;
    }
  },
  actions: {
    updateGlobalVar({ commit }, value) {
      commit('setGlobalVar', value);
    }
  }
});



// WEBPACK FOOTER //
// ./src/utils/store.js